import { useState } from "react"
import { storyblokEditable, renderRichText } from "@storyblok/react"
import { SvgPlus, SvgMinimize } from "../../icons"

export default function FAQItem({ blok, isFirst, isLast }: any) {
  const [open, setOpen] = useState(false)

  return (
    <div
      {...storyblokEditable(blok)}
      className={`px-5 md:px-8 ${isFirst ? "rounded-t-2xl" : ""} ${
        isLast ? "rounded-b-2xl" : ""
      }`}
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="w-full py-5 md:py-6 flex items-center justify-between gap-4 text-left"
      >
        <div
          className="font-['BeausiteClassic'] text-base md:text-lg font-bold text-gray-900"
          dangerouslySetInnerHTML={{
            __html: renderRichText(blok.question || { content: [] }) || "",
          }}
        />
        <span
          className={`flex-shrink-0 transition-transform duration-200 ${
            open ? "rotate-180 text-[#4750F5]" : "text-gray-500"
          }`}
        >
          {open ? (
            <SvgMinimize className="w-6 h-6" />
          ) : (
            <SvgPlus className="w-6 h-6" />
          )}
        </span>
      </button>

      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          open ? "max-h-[1000px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div
          className="pb-6 md:pb-8 font-['BeausiteClassic'] text-sm md:text-base text-gray-700 leading-relaxed"
          dangerouslySetInnerHTML={{
            __html: renderRichText(blok.answer || { content: [] }) || "",
          }}
        />
      </div>
    </div>
  )
}
